import script from "./inbox-communication-container.vue?vue&type=script&setup=true&lang=js"
export * from "./inbox-communication-container.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__